export enum InvoiceDocumentType {
  CreditNote = 'creditnote',
  DeliveryNote = 'deliverynote',
  DeliveryNoteDraft = 'deliverynoteDraft',
  Invoice = 'invoice',
  InvoiceDraft = 'invoiceDraft',
  Quote = 'estimate',
  QuoteDraft = 'estimateDraft',
  Receipt = 'receipt',
  ReceiptDraft = 'receiptDraft',
  RecurringInvoice = 'recurringInvoice',
  RecurringInvoiceDraft = 'recurringInvoiceDraft',
}
